import React from "react"
import { Trans } from "@lingui/react"
import stellarProcessing from "../../view/assets/stellar-animation.gif"
import pending from "../../view/assets/pending.svg"
import done from "../../view/assets/done.svg"
import PropTypes from "prop-types"
import { useDispatch } from "react-redux"
import { triggerAction } from "../../store/constants"
import { fetchVslas } from "../../store/actions/getVslas"

const spinnerStyle = {
  height: "70%",
  width: "70%",
}

const loadingStyle = {
  fontFamily: "Fira Sans",
  fontSize: "20px",
}

const itemStyle = {
  padding: 5,
}

const containerStyle = {
  margin: "auto",
  display: "flex",
  flexDirection: "column",
}

const StellarLoader = (props) => {
  return (
    <div id="stellar-loader" style={{ textAlign: "center" }}>
      <center>
        <img src={stellarProcessing} style={spinnerStyle} alt="Stellar" />
        <br />
        <span style={loadingStyle}>
          <Trans id="loading" />
        </span>
        <p>{props.msg ? props.msg : ""}</p>
      </center>
    </div>
  )
}

StellarLoader.propTypes = {
  msg: PropTypes.string,
}

const IconState = ({ iconStyle, off }) => (
  <img style={{ ...iconStyle, marginLeft: 3 }} src={off ? done : pending} alt="" />
)

IconState.propTypes = {
  iconStyle: PropTypes.object,
  off: PropTypes.bool,
}

const EPOCHES = [10000, 10000, 30000, 10000]
export const GroupCreateLoader = (props) => {
  const dispatch = useDispatch()
  const [timer1, setTimer1] = React.useState(false)
  const [timer2, setTimer2] = React.useState(false)
  const [timer3, setTimer3] = React.useState(false)
  const [timer4, setTimer4] = React.useState(false)

  React.useEffect(() => {
    const timers = [setTimer1, setTimer2, setTimer3, setTimer4]
    const shuffledEpoches = [...EPOCHES].sort(() => Math.random() - 0.5)
    let cumulativeDelay = 0

    const timeouts = timers.map((timerFunc, index) => {
      const delay = shuffledEpoches[index]
      cumulativeDelay += delay
      return setTimeout(() => {
        timerFunc(true)
      }, cumulativeDelay)
    })

    return () => {
      timeouts.forEach(clearTimeout)
    }
  }, [])

  React.useEffect(() => {
    if (timer1 && timer2 && timer3 && timer4) {
      setTimeout(() => {
        dispatch(triggerAction("IS_CREATING_VSLA", false))
        dispatch(fetchVslas())
      }, EPOCHES[0]);
    }
  }, [timer1, timer2, timer3, timer4])

  return (
    <div id="stellar-loader" style={{ display: "flex", flexDirection: "column" }}>
      <center>
        <img src={stellarProcessing} style={spinnerStyle} alt="Stellar" />
      </center>
      <p><Trans id="creating.vsla.msg" /></p>
      <div style={containerStyle}>
        <span style={itemStyle}>
          <IconState iconStyle={props.iconStyle} off={timer1} />
          <Trans id="creating.vsla.group" />
        </span>
        <span style={itemStyle}>
          <IconState iconStyle={props.iconStyle} off={timer2} />
          <Trans id="creating.accounts" />
        </span>
        <span style={itemStyle}>
          <IconState iconStyle={props.iconStyle} off={timer3} />
          <Trans id="creating.member.account" />
        </span>
        <span style={itemStyle}>
          <IconState iconStyle={props.iconStyle} off={timer4} />
          <Trans id="getting.everything.ready" />
        </span>
      </div>
    </div>
  )
}

GroupCreateLoader.propTypes = {
  iconStyle: PropTypes.object,
}

export default StellarLoader
